export default __webpack_public_path__ + "static/media/support_platform_mall3.b3295ad1.png";